import React, { FC } from 'react'
import { getCurrencySymbol } from './helpers'
import { LocaleCurrency } from 'types/Shared/Locale'

type LocaleCurrencySymbolProps = {
  selectedCurrency: LocaleCurrency
}

const LocaleCurrencySymbol: FC<LocaleCurrencySymbolProps> = ({ selectedCurrency }) => {
  return <>{getCurrencySymbol(selectedCurrency)}</>
}

export default LocaleCurrencySymbol
